import { defineStore } from "pinia"
import { ref, computed } from "vue"
import { getQuestions, getAudio } from "@/api/s3/index"
import { useHelpStore } from "@/components/af/Help/help.store.js"
import { shapeActor } from "@/features/shape/machines/shapeMachine"
import type { Ref } from "vue"
import type { Question } from "@/features/shape/store/shape.types.js"

export const useQuestionsStore = defineStore("shapeQuestionsStore", () => {
  const helpStore = useHelpStore()

  const items: Ref<Question[]> = ref([])
  const currentIndex: Ref<number> = ref(0)
  const isLastQuestion: Ref<boolean> = ref(false)

  const currentQuestion = computed<Question>(() => {
    return items.value[currentIndex.value]
  })
  const questionsLength = computed(() => items.value.length)

  async function fetchQuestions() {
    const data = await getQuestions({ test: "shape" })
    items.value = data.questions

    return items.value
  }

  function fetchAudios() {
    getAudio({ test: "shape" })
  }

  // if current question is not the last one of the list, increment the index
  async function goNext() {
    if (currentIndex.value === items.value.length - 1) {
      isLastQuestion.value = true
      shapeActor.send({ type: "done" })
    } else {
      currentIndex.value++
      if (helpStore.isAudioHelpAccepted) {
        helpStore.startAudioSequence()
      }
    }
  }

  function setCurrentIndex(id: number) {
    currentIndex.value = id
  }

  return {
    questions: items.value,
    currentIndex,
    currentQuestion,
    questionsLength,
    isLastQuestion,
    fetchQuestions,
    fetchAudios,
    goNext,
    setCurrentIndex,
  }
})
